var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M24 15.995c1.686 0 3.07 1.323 3.218 3.012h2.954a.828.828 0 010 1.655h-.249v8.264a.754.754 0 01-.008.11C29.84 30.234 29.188 31 28.066 31h-8.394c-1.032 0-1.542-.803-1.591-2.01a.444.444 0 01-.004-.064l-.001-8.265-.248.001a.828.828 0 010-1.655h2.954c.148-1.689 1.532-3.012 3.218-3.012zm4.307 4.666h-1.615v8.683h1.077c.187 0 .484-.042.532-.435l.007-.116-.001-8.132zm-7 0h-1.615v8.198c.003.219.03.441.327.48l.097.006h1.191V20.66zm3.769 0h-2.153v8.683h2.153v-8.683zM24 17.651c-.792 0-1.451.584-1.589 1.355h3.178c-.138-.77-.797-1.355-1.589-1.355z", fill: "currentColor" }),
            React.createElement("circle", { stroke: "currentColor", strokeWidth: 2, cx: 24, cy: 24, r: 11 }))));
});
